import { render, staticRenderFns } from "./memberDetail.vue?vue&type=template&id=11d5a0da&scoped=true&"
import script from "./memberDetail.vue?vue&type=script&lang=js&"
export * from "./memberDetail.vue?vue&type=script&lang=js&"
import style0 from "./memberDetail.vue?vue&type=style&index=0&id=11d5a0da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d5a0da",
  null
  
)

export default component.exports